export default {
  primary: '"Knockout-Middleweight", Helvetica, sans-serif',
  secondary: '"Knockout-Full-Sumo", Helvetica, sans-serif',
  tertiary: '"Knockout-Junior-Middleweight", Helvetica, sans-serif',
};
